


















import { Component, Prop, Vue } from 'vue-property-decorator';
import NavbarDark from '@/components/NavbarDark.vue';
import Footer from '@/components/Footer.vue';

@Component({
  components: {
    NavbarDark,
    Footer,
  },
})
export default class SiEresCandidato extends Vue {
  public goToBuy() {
    window.location.href = 'https://shop.toothly.mx/products/kit-de-impresiones-toothly';
  }
}
